// §29.2 / §9.1 — FreeCell as an in-process app.
//
// The manifest **only** (D-247): the engine, the view, the card kit and the generated deck all live
// behind the `import()` below, so a visitor who never opens FreeCell never downloads a card.
//
// `requiresAuth` (D-359): all eleven wave-2 titles are behind sign-in and Solitaire stays the one
// game a guest can play. Widening that exception would reopen the guest-persistence paths wave 1
// deliberately closed, for no story that needs them.
import type { ArcadeShellAccess, InProcessApp } from '@hangar/shared';
import { createLazyApp } from '@/gamekit/lazy';

export function createFreeCellApp(access: ArcadeShellAccess): InProcessApp {
  return createLazyApp<{ access: ArcadeShellAccess }>({
    app: {
      id: 'freecell',
      name: 'FreeCell',
      icon: { glyph: 'columns-3', hue: 155 },
      keywords: ['cards', 'freecell', 'patience', 'solitaire', 'game', 'arcade'],
      category: 'Arcade',
      // §29.1 (D-369) — the Cards sub-group header, shared with Pyramid.
      group: 'Cards',
      requiresAuth: true,
      window: { width: 980, height: 700, minWidth: 640, minHeight: 480, multiWindow: false },
      jumpList: [
        { id: 'new-game', label: 'New game' },
        { id: 'daily-deal', label: 'Daily deal' },
        { id: 'continue', label: 'Continue' },
      ],
    },
    load: () => import('./FreeCell'),
    props: { access },
  });
}
